<div class="generic-inline-list" role="group"
  [attr.aria-label]="resolvedTranslations.labels.groupLabel">
  <p *ngIf="data.length === 0" class="uba-inline-item-list__empty">
    {{ resolvedTranslations.labels.emptyList }}
  </p>
  <ul [id]="idPrefix + '-list'" class="uba-inline-item-list">
    <li class="uba-inline-item-list__item" *ngFor="let item of data; let i = index">
      <span class="sr-only">
        {{ t('labels.itemEntry', { index: i + 1, total: data.length }) }}
      </span>
      <ng-container
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="getItemContext(item, i)">
      </ng-container>
      <button
        *ngIf="!readonly"
        type="button"
        class="btn btn-danger btn-form-default"
        [disabled]="!canRemove(item, i)"
        [title]="t('buttons.removeItem', { index: i + 1 })"
        [attr.aria-label]="t('buttons.removeItem', { index: i + 1 })"
        (click)="removeItem(i)">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </li>
  </ul>
  <div *ngIf="!readonly" class="uba-inline-item-list__append">
    <button
      type="button"
      class="btn btn-success"
      [title]="resolvedTranslations.buttons.appendItem"
      [attr.aria-label]="resolvedTranslations.buttons.appendItemLabel"
      (click)="appendItem()"
      [attr.aria-controls]="idPrefix + '-list'">
      <i class="fas fa-plus" aria-hidden="true"></i> {{ resolvedTranslations.buttons.appendItem }}
    </button>
  </div>
</div>
